import { Routes } from '@angular/router';
import { LandingPageComponent } from '../pages/landing-page/landing-page.component';
import { HomePageComponent } from '../pages/home-page/home-page.component';
import { adminGuard, authGuard, reverseAuthGuard, autoLoginGuard, adminCFGuard } from './auth.guard';
import { SchedulingPageComponent } from '../pages/scheduling-page/scheduling-page.component';
import { SlurryOptimizationPageComponent } from '../pages/slurry-optimization-page/slurry-optimization-page.component';
import { SoilCompactionPageComponent } from '../pages/soil-compaction-page/soil-compaction-page.component';
import { OSMPageComponent } from '../pages/osm-page/osm-page.component';
import { NotFoundPageComponent } from '../pages/not-found-page/not-found-page.component';
import { FeedbackPageComponent } from '../pages/admin-page/feedback-page/feedback-page.component';
import { GeoBirdPageComponent } from '../pages/geo-bird-page/geo-bird-page.component';
import { AnalyticsComponent } from '../pages/admin-page/analytics/analytics.component';
import { FeedbackComponent } from '../pages/admin-page/feedback/feedback.component';
import { GuidancePageComponent } from '../pages/guidance-page/guidance-page.component';
import { WildOatsMappingComponent } from '../pages/wild-oats-mapping/wild-oats-mapping-page.component';
import { ServiceMetricsComponent } from '../pages/admin-page/service-metrics/service-metrics.component';
import { ServiceMetricsPageComponent as SMPComponent } from '../pages/admin-page/service-metrics-page/service-metrics-page.component';

export const routes: Routes = [
  {
    path: 'auto-login',
    component: HomePageComponent,
    canActivate: [autoLoginGuard],
    data: { breadcrumb: $localize`home` },
  },
  {
    path: 'scheduling',
    component: SchedulingPageComponent,
    canActivate: [authGuard],
    data: { breadcrumb: $localize`Scheduling` },
  },
  {
    path: 'slurry-optimization',
    component: SlurryOptimizationPageComponent,
    canActivate: [authGuard],
    data: { breadcrumb: $localize`SLURRY OPTIMIZATION` },
  },
  {
    path: 'soil-compaction',
    component: SoilCompactionPageComponent,
    canActivate: [authGuard],
    data: { breadcrumb: $localize`Soil Compaction` },
  },
  {
    path: 'public-landscape-objects',
    component: OSMPageComponent,
    canActivate: [authGuard],
    data: { breadcrumb: $localize`Public landscape objects` },
  },
  {
    path: 'wild-oats-mapping',
    component: WildOatsMappingComponent,
    canActivate: [authGuard],
    data: { breadcrumb: $localize`Wild Oats Mapping` },
  },
  {
    path: 'guidance-data-converter',
    component: GuidancePageComponent,
    canActivate: [authGuard],
    data: { breadcrumb: $localize`Guidance data converter` },
  },
  {
    path: 'geo-bird',
    component: GeoBirdPageComponent,
    canActivate: [authGuard],
    data: { breadcrumb: $localize`home` },
  },
  { path: 'home', component: HomePageComponent, canActivate: [authGuard], data: { breadcrumb: $localize`home` } },
  {
    path: 'customer-feedback',
    loadComponent: () =>
      import('../pages/customer-feedback-page/customer-feedback-page.component').then(
        (m) => m.CustomerFeedbackPageComponent,
      ),
    canActivate: [adminCFGuard],
    data: { breadcrumb: $localize`IDEAL Customer Feedback` },
  },
  {
    path: 'admin',
    loadComponent: () => import('../pages/admin-page/admin-page.component').then((m) => m.AdminPageComponent),
    canActivate: [adminGuard],
    data: { breadcrumb: $localize`administration` },
    children: [
      { path: 'analytics', component: AnalyticsComponent, data: { breadcrumb: $localize`Analytics` } },
      { path: 'feedback', component: FeedbackComponent, data: { breadcrumb: $localize`Feedback` } },
      { path: 'feedback/:feature', component: FeedbackPageComponent, data: { breadcrumb: $localize`Feedback` } },
      { path: 'service-metrics', component: ServiceMetricsComponent, data: { breadcrumb: $localize`Service Metrics` } },
      { path: 'service-metrics/:service', component: SMPComponent, data: { breadcrumb: $localize`Service Metrics` } },
      { path: '', redirectTo: 'analytics', pathMatch: 'full' },
    ],
  },
  {
    path: '',
    component: LandingPageComponent,
    pathMatch: 'full',
    canActivate: [reverseAuthGuard],
  },
  {
    path: '**',
    component: NotFoundPageComponent,
  },
];
